"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = csvToIntArray;
function csvToIntArray(string) {
  return string.split(',').map(function (a) {
    return parseInt(a, 10);
  });
}